/** Opt out of the global React Query error toast when a hook or page handles UX locally. */
export const suppressGlobalErrorToastMeta = { suppressGlobalErrorToast: true } as const;

export function shouldSuppressGlobalErrorToast(
  meta: Record<string, unknown> | undefined,
): boolean {
  return meta?.suppressGlobalErrorToast === true;
}
